import { render, staticRenderFns } from "./SendQuotationDialog.vue?vue&type=template&id=5bc5bcb6"
import script from "./SendQuotationDialog.vue?vue&type=script&lang=js"
export * from "./SendQuotationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports